// extracted by mini-css-extract-plugin
export default {"card":"CardUI_card__+3gwo"};